// extracted by mini-css-extract-plugin
export default {"hidden":"MSbx8x","link":"AAkHBS","active":"lSZPzp","svg":"k4KfHp","prev":"eQW7Zd","link-active":"yQ92Me","linkActive":"yQ92Me"};